<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import TopicSuggestionOverlay from '@/components/overlays/group/TopicSuggestionOverlay'

  export default {
    name: 'TopicSuggestions',
    components: {
      TopicSuggestionOverlay,
    },
    props: {
      suggestions: Array,
    },
    data() {
      return {
        selectedTopic: null,
      }
    },
    methods: {
      closeOverlay() {
        this.selectedTopic = null
      },
      onAccept(id) {
        this.$emit('accept', id)
      },
      onDecline(id) {
        this.$emit('decline', id)
      },
    },
  }
</script>
